import { Tooltip as AntdTooltip, TooltipProps } from 'antd'

const Tooltip = (props: TooltipProps) => {
  return <AntdTooltip {...props} />
}

export default Tooltip
